import { cssVar } from 'src/app/styles/helper';
import { css } from 'styled-components';

const smallButtonStyles = css`
  padding: ${cssVar('spacing-md')} ${cssVar('spacing-lg')};
  border-radius: ${cssVar('radius-md')};
  font-size: ${cssVar('font-size-text-sm')};
  line-height: ${cssVar('line-height-text-sm')};
`;

const mediumButtonStyles = css`
  padding: 10px 14px;
  font-size: ${cssVar('font-size-text-sm')};
  line-height: ${cssVar('line-height-text-sm')};
  border-radius: ${cssVar('radius-md')};
`;

const largeButtonStyles = css`
  padding: 10px ${cssVar('spacing-xl')};
  border-radius: ${cssVar('radius-md')};
  font-size: ${cssVar('font-size-text-md')};
  line-height: ${cssVar('line-height-text-md')};
`;

const xLargeButtonStyles = css`
  padding: ${cssVar('spacing-lg')} 18px;
  border-radius: ${cssVar('radius-md')};
  font-size: ${cssVar('font-size-text-md')};
  line-height: ${cssVar('line-height-text-md')};
`;

export const BUTTON_SIZE_STYLES = {
  sm: smallButtonStyles,
  md: mediumButtonStyles,
  lg: largeButtonStyles,
  xl: xLargeButtonStyles,
};
